import { createSlice } from '@reduxjs/toolkit';

export const DEFAULT_PROMO_DAY = 3;
export const CRYPTO_CRYSTALS_DEFAULT_PROMO_DAY = 5;

const initialState = {
    // Стандартные дни
    standardDays: [1, 2, 3, 4, 5, 7, 10, 15, 27],
    
    // Кастомные дни (добавленные пользователем)
    customDays: [],
    
    // Выбранный день (дефолт 3 дня)
    selectedDay: DEFAULT_PROMO_DAY,
    
    // Загрузка и ошибки
    isLoading: false,
    error: null
};

const promoTimeSlice = createSlice({
    name: 'promoTime',
    initialState,
    reducers: {
        // Добавить кастомный день
        addCustomDay: (state, action) => {
            const newDay = action.payload;
            
            // Проверяем, что день валидный
            if (newDay >= 1 && newDay <= 27) {
                // Проверяем, что такого дня еще нет
                const allDays = [...state.standardDays, ...state.customDays];
                if (!allDays.includes(newDay)) {
                    state.customDays.push(newDay);
                    // Сортируем кастомные дни
                    state.customDays.sort((a, b) => a - b);
                }
            }
        },
        
        // Удалить кастомный день
        removeCustomDay: (state, action) => {
            const dayToRemove = action.payload;
            state.customDays = state.customDays.filter(day => day !== dayToRemove);
        },
        
        // Выбрать день
        selectDay: (state, action) => {
            state.selectedDay = action.payload;
        },
        
        // Сбросить выбранный день
        clearSelectedDay: (state) => {
            state.selectedDay = DEFAULT_PROMO_DAY;
        },
        
        // Сбросить все кастомные дни
        clearCustomDays: (state) => {
            state.customDays = [];
        },
        
        // Установить загрузку
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        
        // Установить ошибку
        setError: (state, action) => {
            state.error = action.payload;
        },
        
        // Сбросить состояние
        resetPromoTime: (state) => {
            state.customDays = [];
            state.selectedDay = DEFAULT_PROMO_DAY;
            state.isLoading = false;
            state.error = null;
        }
    }
});

// Экспортируем actions
export const {
    addCustomDay,
    removeCustomDay,
    selectDay,
    clearSelectedDay,
    clearCustomDays,
    setLoading,
    setError,
    resetPromoTime
} = promoTimeSlice.actions;

// Селекторы
export const selectAllDays = (state) => {
    const { standardDays, customDays } = state.promoTime;
    return [...standardDays, ...customDays].sort((a, b) => a - b);
};

export const selectStandardDays = (state) => state.promoTime.standardDays;
export const selectCustomDays = (state) => state.promoTime.customDays;
export const selectSelectedDay = (state) => state.promoTime.selectedDay;
export const selectIsLoading = (state) => state.promoTime.isLoading;
export const selectError = (state) => state.promoTime.error;

export default promoTimeSlice.reducer;
